import React from 'react';
import { Modal, ModalInner, Button } from 'components';

interface MultipleDeleteModalProps {
  isOpened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  selectedCount: number;
}

const MultipleDeleteModal = ({ 
  isOpened, 
  onClose, 
  onConfirm, 
  loading = false,
  selectedCount 
}: MultipleDeleteModalProps) => {
  if (!isOpened) return null;

  return (
    <Modal isOpened={isOpened}>
      <ModalInner 
        className="md:w-[500px]" 
        title="삭제 확인" 
        onClickClose={onClose}
      >
        <div className="p-6 pt-0 space-y-4">
          <div className="text-center">
            <p className="text-lg font-medium text-gray-900 mb-2">
              선택된 프로모션을 삭제하시겠습니까?
            </p>
            <p className="text-sm text-gray-600">
            <span className="font-semibold text-red-600">{selectedCount}개</span>의 프로모션이 영구적으로 삭제됩니다.
            </p>
            <p className="text-xs text-gray-500 mt-2">
              이 작업은 되돌릴 수 없습니다.
            </p>
          </div>
        </div>

        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button 
            className="h-9" 
            text="Cancel" 
            onClick={onClose} 
            type="secondary" 
            size="large" 
            disabled={loading}
          />
          <Button 
            className="h-9 bg-red-600 border-red-600 hover:bg-red-700" 
            text={loading ? "Deleting..." : "Delete"} 
            onClick={onConfirm} 
            size="large" 
            disabled={loading}
          />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default MultipleDeleteModal;

